<template>
  <div class="banner-slider-container position-relative">
    <aside
      class="slider-banner-first"
      :class="{ 'banner-cover': _loadedBanner, 'banner-hidden': _loadedBanner && activeIndex !== 0 }"
      id="wrapper-content-first"
    >
      <BannerFirst
        ref="bannerFirstRef"
        :pageSluga="props.currentLang || props.pageSlug"
        :initial-banner="props.firstBanner"
        @media-ready="firstMediaReady = true"
      />
    </aside>
    <section v-if="dataLoad && _loadedBanner" class="sk-home__section sk-home__section--sliderbanner" id="section-sliderbanner">
    <div class="mx-0 home__banner-slider home__banner-slider" id="home__banner-slider" >
      <Swiper
        class="banner-swiper"
        :modules="swiperModules"
        :slides-per-view="1"
        :effect="'fade'"
        :fade-effect="{ crossFade: true }"
        :speed="1000"
        :rewind="true"
        :allow-touch-move="true"
        :autoplay="swiperAutoplay"
        @swiper="onSwiperInit"
        @slide-change="onSwiperSlideChange"
        aria-label="Products"
      >
          <SwiperSlide v-for="(item, index) in items" :key="item.id" :class="['item ', item?.image_banner_item_type]">
            <div class="top_banner position-relative">
              <a class="inner_top_banner" target="_self" :href="item?.cta.cta_link"
                v-if="item?.image_banner_item_type == 'image'">
                <img width="1654" height="517" :class="[
                  { 'alt-lazy-img ': index == 0 },
                  { 'banner-lazy-img ': index > 0 }, 'pc_banner']
                  " v-if="item?.img_pc.lazy && item?.image_banner_item_type == 'image'" :src="item.img_pc.lazy"
                  :alt="item.img_pc?.alt || 'image'" :data-original_src="item.img_pc.full"
                  @load="onOriginalImageLoad($event, item, 'pc', item.img_pc.full)">
                <img width="900" height="840"
                  :class="[{ 'alt-lazy-img ': index == 0 }, { 'banner-lazy-img ': index > 0 }, 'mobile_banner']"
                  v-if="item?.mb_image.full && item?.image_banner_item_type == 'image'" :src="item.mb_image.lazy"
                  :alt="item.mb_image?.alt || 'image'" :data-original_src="item.mb_image.full"
                  @load="onOriginalImageLoad($event, item, 'mb', item.mb_image.full)">
              </a>
              <div class="wrapper-banner-video inner_top_banner" v-if="item?.image_banner_item_type === 'video'">
                <!-- The poster is only needed before this video first plays. -->
                <template v-if="hasPcVideo(item)">
                  <video
                    v-if="!isFirstSlideCovered(index)"
                    :ref="(element) => setVideoRef(item.id, 'pc', element)"
                    :poster="isVideoReady(item.id, 'pc') ? undefined : getPcPoster(item)"
                    autoplay
                    muted
                    playsinline
                    loop
                    preload="none"
                    class="video_banner pc_banner"
                    :id="'video_banner_pc_' + item.id"
                    @playing="onVideoReady(item.id, 'pc')"
                  >
                    <source v-if="videoSourcesLoaded[videoKey(item.id, 'pc')]" :src="item.pc_video.video_url_pc" type="video/mp4">
                  </video>
                  <img
                    class="pc_banner banner_poster_img"
                    :class="{ 'poster-hidden': isVideoReady(item.id, 'pc') || isFirstSlideCovered(index) }"
                    :src="getPcPoster(item)"
                    :alt="item.pc_video?.alt || item.img_pc?.alt || item.title_heading || 'banner'"
                    width="1654"
                    height="517"
                    :loading="index === 0 ? 'eager' : 'lazy'"
                    :fetchpriority="index === 0 ? 'high' : 'auto'"
                    @load="onPosterLoad(item, 'pc')"
                  >
                </template>
                <img
                  v-else
                  class="pc_banner"
                  :src="getPcPoster(item)"
                  :alt="item.img_pc?.alt || item.title_heading || 'banner'"
                  width="1654"
                  height="517"
                  :loading="index === 0 ? 'eager' : 'lazy'"
                  :fetchpriority="index === 0 ? 'high' : 'auto'"
                  @load="onOriginalImageLoad($event, item, 'pc', getPcPoster(item))"
                >

                <template v-if="hasMbVideo(item)">
                  <video
                    v-if="!isFirstSlideCovered(index)"
                    :ref="(element) => setVideoRef(item.id, 'mb', element)"
                    :poster="isVideoReady(item.id, 'mb') ? undefined : getMbPoster(item)"
                    autoplay
                    muted
                    playsinline
                    loop
                    preload="none"
                    class="video_banner mobile_banner"
                    :id="'video_banner_mb_' + item.id"
                    @playing="onVideoReady(item.id, 'mb')"
                  >
                    <source v-if="videoSourcesLoaded[videoKey(item.id, 'mb')]" :src="item.mb_video.video_url_mb" type="video/mp4">
                  </video>
                  <img
                    class="mobile_banner banner_poster_img"
                    :class="{ 'poster-hidden': isVideoReady(item.id, 'mb') || isFirstSlideCovered(index) }"
                    :src="getMbPoster(item)"
                    :alt="item.mb_video?.alt || item.mb_image?.alt || item.title_heading || 'banner'"
                    width="900"
                    height="840"
                    :loading="index === 0 ? 'eager' : 'lazy'"
                    :fetchpriority="index === 0 ? 'high' : 'auto'"
                    @load="onPosterLoad(item, 'mb')"
                  >
                </template>
                <img
                  v-else
                  class="mobile_banner"
                  :src="getMbPoster(item)"
                  :alt="item.mb_image?.alt || item.title_heading || 'banner'"
                  width="900"
                  height="840"
                  :loading="index === 0 ? 'eager' : 'lazy'"
                  :fetchpriority="index === 0 ? 'high' : 'auto'"
                  @load="onOriginalImageLoad($event, item, 'mb', getMbPoster(item))"
                >
              </div>

              <div class="home__content-banner" :class="item.content_position"
                :style="{ color: item?.content_text_color }" :data-colorMb="item?.content_text_color_mb"
                :data-color="item?.content_text_color">
                <h3 class="subheading-banner" v-if="item?.sub_heading">
                  <span class="subheading-banner__line-left" :style="{ background: item?.content_text_color }"></span>
                  <span class="subheading-banner_main-title" :style="{ color: item?.content_text_color }"
                    v-html="item?.sub_heading"></span>
                  <span class="subheading-banner__line-right" :style="{ background: item?.content_text_color }"></span>
                </h3>
                <h2 class="heading-banner" v-if="item?.heading" v-html="item?.heading"
                  :style="{ color: item?.content_text_color }"></h2>
                <div class="content-banner" v-if="item?.description" v-html="item?.description"></div>

                <a v-if="item?.cta.cta_text && item?.cta.cta_link && !item?.active_cny" class="btn_act" :class="item?.cta.cta_size"
                  target="_self" :href="getLangUrl(item?.cta.cta_link, baseUrl, locale)"
                  :style="{ background: item?.cta.cta_bg_color, color: item?.cta.cta_text_color }">
                  {{ item?.cta.cta_text }}
                  <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5.5H18.55M18.55 5.5L13.8625 1M18.55 5.5L13.8625 10" :stroke="item?.cta.cta_text_color"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
                <a v-if="item?.cta.cta_text && item?.cta.cta_link && item?.active_cny" @click.prevent="loadingAtcCny"  class="btn_act" :class="item?.cta.cta_size"
                  target="_self" href="/cny"
                  :style="{ background: item?.cta.cta_bg_color, color: item?.cta.cta_text_color }">
                  {{ item?.cta.cta_text }}
                  <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5.5H18.55M18.55 5.5L13.8625 1M18.55 5.5L13.8625 10" :stroke="item?.cta.cta_text_color"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </div>
              <div class="slider_home_title" v-if="items.length > 1">
                  <h3>{{ item?.title_heading }}</h3>
              </div>
            </div>
          </SwiperSlide>
      </Swiper>

      <template v-if="hasMultipleSlides">
        <button
          v-if="sliderSetting.arrow_banner"
          class="banner-arrow banner-arrow--prev"
          type="button"
          aria-label="Previous slide"
          @click="bannerSwiper?.slidePrev()"
        >
          <svg viewBox="0 0 256 512" aria-hidden="true">
            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
          </svg>
        </button>
        <button
          v-if="sliderSetting.arrow_banner"
          class="banner-arrow banner-arrow--next"
          type="button"
          aria-label="Next slide"
          @click="bannerSwiper?.slideNext()"
        >
          <svg viewBox="0 0 256 512" aria-hidden="true">
            <path d="M246.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 41.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" />
          </svg>
        </button>
        <div v-if="sliderSetting.show_paginations" class="swiper-pagination swiper-pagination--banner" aria-label="Banner pagination">
          <button
            v-for="(_, index) in items"
            :key="index"
            class="swiper-pagination__bullet"
            :class="{ 'is-active': activeIndex === index }"
            type="button"
            :aria-label="`Go to slide ${index + 1}`"
            :aria-current="activeIndex === index ? 'true' : undefined"
            @click="goToSlide(index)"
          >
            <span v-if="activeIndex === index" :key="`${index}-${progressKey}`" class="progress-bar"></span>
          </button>
        </div>
      </template>
    </div>

  </section>
  </div>
  <LoadingCny v-if="loading_cny" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
const props = defineProps(["language", 'currencySetting', 'pageSlug', 'currentLang', 'firstBanner']);
const language = props.language;
const { $file } = useNuxtApp();
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
const wooStore = useWooStore();
const countryShort = wooStore.country?.country_short;
import BannerFirst from "@/components/Home/BannerSliderFirst.vue";
const LoadingCny = defineAsyncComponent(() => import('@/components/Home/Loading_cny.vue'));

import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
const router = useRouter();
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl } from '~/utils/getLangUrl';

const items = ref<any[]>([]);
let dataLoad = ref(false);
const isLoadingItems = ref(false);
const hasActivatedMainSlider = ref(false);
const sliderSetting = ref<Record<string, any>>({});
const userStore = useUserStore();
const showMainBanner = ref(false);
const _loadedBanner = ref(false);
const firstMediaReady = ref(false);
const mainMediaReady = ref(false);
const checkMobile = ref(false);
const bannerSwiper = ref();
const loading_cny = ref(false);
const isMobileViewport = ref(false);
const videoLoadingEnabled = ref(false);
const videoPosterLoaded = reactive<Record<string, boolean>>({});
// This records first playback, not whether the video is currently playing.
const videoHasPlayed = reactive<Record<string, boolean>>({});
const videoSourcesLoaded = reactive<Record<string, boolean>>({});
const videoRefs = new Map<string, HTMLVideoElement>();
const loadedVideoSources = new WeakMap<HTMLVideoElement, string>();
const pendingVideoPlays = new WeakSet<HTMLVideoElement>();


const activeIndex = ref(0);
const progressKey = ref(0);
const swiperModules = [Autoplay, EffectFade];
const hasMultipleSlides = computed(() => items.value.length > 1);
const swiperAutoplay = computed(() => sliderSetting.value?.autoplay
  ? { delay: 20000, disableOnInteraction: false, pauseOnMouseEnter: false }
  : false);

type VideoViewport = 'pc' | 'mb';

const videoKey = (id: string | number, viewport: VideoViewport) => `${id}-${viewport}`;
const hasPcVideo = (item: any) => Boolean(item?.pc_video?.video_url_pc);
const hasMbVideo = (item: any) => Boolean(item?.mb_video?.video_url_mb);
const getPcPoster = (item: any) => item?.pc_video?.full || item?.pc_video?.lazy || item?.img_pc?.full || item?.img_pc?.lazy;
const getMbPoster = (item: any) => item?.mb_video?.full || item?.mb_video?.lazy || item?.mb_image?.full || item?.mb_image?.lazy;
const bannerFirstRef = ref<any>(null);

const isFirstSlideCovered = (index: number) => {
  return index === 0 && Boolean(props.firstBanner || firstMediaReady.value);
};

const isVideoReady = (id: string | number, viewport: VideoViewport) => {
  if (items.value[0]?.id === id && isFirstSlideCovered(0)) {
    return true;
  }
  return Boolean(videoHasPlayed[videoKey(id, viewport)]);
};
const isActiveVideo = (item: any) => items.value[activeIndex.value]?.id === item?.id;

const setVideoRef = (id: string | number, viewport: VideoViewport, element: Element | null) => {
  const key = videoKey(id, viewport);
  if (element instanceof HTMLVideoElement) videoRefs.set(key, element);
  else videoRefs.delete(key);
};

const shouldLoadVideo = (item: any, viewport: VideoViewport) => {
  if (items.value[0]?.id === item?.id && isFirstSlideCovered(0)) {
    return false;
  }
  const isCurrentViewport = viewport === 'mb' ? isMobileViewport.value : !isMobileViewport.value;
  return videoLoadingEnabled.value && !document.hidden && isCurrentViewport && isActiveVideo(item) && Boolean(videoPosterLoaded[videoKey(item.id, viewport)]);
};

const startVideo = async (item: any, viewport: VideoViewport) => {
  if (!shouldLoadVideo(item, viewport)) return;
  const key = videoKey(item.id, viewport);
  // Keep an already loaded source mounted when changing slides or viewports.
  videoSourcesLoaded[key] = true;
  await nextTick();
  const video = videoRefs.get(key);
  if (!video || !shouldLoadVideo(item, viewport) || pendingVideoPlays.has(video)) return;
  const source = video.querySelector('source')?.src;
  if (!source) return;
  // Mobile browser toolbar resizes must not reload the currently playing media.
  if (loadedVideoSources.get(video) !== source) {
    videoHasPlayed[key] = false;
    loadedVideoSources.set(video, source);
    video.load();
  }
  if (!video.paused) return;
  video.muted = true;
  pendingVideoPlays.add(video);
  try {
    await video.play();
  } catch {
    // Keep the initial poster, or the existing video frame after first playback.
  } finally {
    pendingVideoPlays.delete(video);
  }
};

const onPosterLoad = (item: any, viewport: VideoViewport) => {
  videoPosterLoaded[videoKey(item.id, viewport)] = true;
  startVideo(item, viewport);
};

const onVideoReady = (id: string | number, viewport: VideoViewport) => {
  const video = videoRefs.get(videoKey(id, viewport));
  if (video && !video.paused && video.readyState >= 2) {
    videoHasPlayed[videoKey(id, viewport)] = true;
    if (items.value[activeIndex.value]?.id === id && viewport === (isMobileViewport.value ? 'mb' : 'pc')) {
      mainMediaReady.value = true;
    }
  }
};

const onOriginalImageLoad = (event: Event, item: any, viewport: VideoViewport, source?: string) => {
  const image = event.target as HTMLImageElement;
  if (!source || !image.naturalWidth || !isActiveVideo(item) || viewport !== (isMobileViewport.value ? 'mb' : 'pc')) return;
  // A lazy thumbnail must not replace the original media already on screen.
  if (image.currentSrc === new URL(source, document.baseURI).href) mainMediaReady.value = true;
};

const pauseVideos = () => {
  bannerFirstRef.value?.pauseVideos();
  videoRefs.forEach((video) => video.pause());
};

const syncVideoPlayback = () => {
  items.value.forEach((item) => {
    (['pc', 'mb'] as const).forEach((viewport) => {
      if (shouldLoadVideo(item, viewport)) {
        void startVideo(item, viewport);
      } else {
        videoRefs.get(videoKey(item.id, viewport))?.pause();
      }
    });
  });
};

const updateVideoViewport = () => {
  isMobileViewport.value = window.matchMedia('(max-width: 999px)').matches;
};

const resetAutoplay = () => {
  if (bannerSwiper.value?.autoplay) {
    bannerSwiper.value.autoplay.stop();
    bannerSwiper.value.autoplay.start();
  }
}
function resetProgressBar() {
  // Re-create the active indicator so its CSS animation restarts on every slide.
  progressKey.value++;
}

const loadingAtcCny = () => {
  loading_cny.value = true;
  
  const pageElement = document.getElementById('page');
  if (pageElement) {
    pageElement.style.top = '0px';
  }
  
  let cnyUrl = '/cny';
   
   setTimeout(() => {
      router.push(cnyUrl);
   }, 800);
}


const handleStyleTopOption = () => {
  const banners = document.querySelectorAll(".home__banner-slider .top_banner .inner_top_banner img");
  let maxHeight = 0;
  let loadedImagesCount = 0;

  const updateMaxHeight = () => {
    banners.forEach((banner) => {
      const bannerHeight = banner.clientHeight || 0;
      if (bannerHeight > maxHeight) {
        maxHeight = bannerHeight;
      }
    });
    banners.forEach((banner) => {
      banner.style.height = maxHeight + "px";
    });

    // console.log('maxHeight:', maxHeight);

    const btn_option = document.querySelector(".home__banner-slider .tab-options");
    if (btn_option) {
      btn_option.style.top = (maxHeight + 25) + "px";
    }
  };

  banners.forEach((banner) => {
    if (banner.complete) {
      loadedImagesCount++;
      if (loadedImagesCount === banners.length) {
        updateMaxHeight();
      }
    } else {
      banner.addEventListener('load', () => {
        loadedImagesCount++;
        if (loadedImagesCount === banners.length) {
          updateMaxHeight();
        }
      });
    }
  });
};

const goToSlide = (index) => {
  if (bannerSwiper.value) {
    bannerSwiper.value.slideTo(index);
    activeIndex.value = index;
  }
};


const onItemActive = (swiper) => {
  activeIndex.value = swiper.realIndex;
  if (activeIndex.value === 0) {
    bannerFirstRef.value?.syncVideoPlayback();
  } else {
    bannerFirstRef.value?.pauseVideos();
  }
  syncVideoPlayback();
}


// color content slider in mobile
const colorSliderMb = () => {
  const isMobileScreen = window.innerWidth < 768;
  // if (!isMobileScreen) return;

  // Use querySelectorAll to select elements with a specific class
  let itemsContent = document.querySelectorAll('.home__content-banner');

  // Loop through each selected element
  itemsContent.forEach((item, index) => {
    let colorItem = item.getAttribute('data-color');
    if (isMobileScreen)
      colorItem = item.getAttribute('data-colormb');

    // To set the text color, use style.color
    item.style.color = colorItem;

    // To select a child element, use querySelector
    let subheadingBannerLineLeft = item.querySelector('.subheading-banner__line-left');
    let subheadingBannerLineRight = item.querySelector('.subheading-banner__line-right');

    // Check if the subheadingBannerLineLeft exists before trying to style it
    if (subheadingBannerLineLeft) {
      subheadingBannerLineLeft.style.background = colorItem;
    }
    if (subheadingBannerLineRight) {
      subheadingBannerLineRight.style.background = colorItem;
    }
  });
};


//Load items from localStorage
const loadItems = async () => {
  if (dataLoad.value || isLoadingItems.value) return;

  isLoadingItems.value = true;
  try {
    let fileName = 'sksg_home_sliderbanner.json';
    let targetFileName = fileName;

    const currentLanguage = props.currentLang || props.pageSlug;
    if (typeof currentLanguage !== 'undefined' && currentLanguage !== '') {
      targetFileName = `${currentLanguage}_${fileName}`;
    }

    const fetchDataSlider = async (file: string, useAsync = true) => {
      // console.log('Fetching file:', `home/${file}`);

      const request = () => 
        $file.get(`home/${file}`, {
          headers: {
            Authorization: `Bearer ${userStore.csrf}`,
            'X-API-Server': userStore.csrf_server,
          },
        });

      if (useAsync) {
        const { data } = await useAsyncData('homepageSlider', request);
        return data;
      } else {
        return await request();
      }
    };

    let response = await fetchDataSlider(targetFileName, true);

    if (!response?.value?.success && targetFileName !== fileName) {
      response = await fetchDataSlider(fileName, false);
    }

    if (response?.value?.success || response?.success) {
      const data = response?.value ?? response;
      items.value = data.items;
      sliderSetting.value = data.slider_setting;
      dataLoad.value = true;
    }
  } catch (error) {
    console.error('Error:', error);
  } finally {
    isLoadingItems.value = false;
  }
};

// const loadItems = async () => {
//   try {
//     let fileName: string = 'sksg_home_sliderbanner.json';
//     if (typeof props.currentLang !== 'undefined' && props.currentLang !== '') {
//       fileName = `${props.currentLang}_${fileName}`;
//     }
//     console.log('fileNamexxx', fileName);
//     const response = await $file.get(`home/${fileName}`, {
//       headers: {
//         Authorization: `Bearer ${userStore.csrf}`,
//         'X-API-Server': userStore.csrf_server
//       },
//     });
//     // const response = await faceApi();

//     if (response.success) {
//       items.value = response.items;
//       sliderSetting.value = response.slider_setting;
//       dataLoad.value = true;
//     }
//   } catch (error) {
//     console.error(error);
//   }
// };


const centerArrows = () => {
  const isMobileScreen = window.innerWidth <= 767;
  let images = document.querySelectorAll('.home__banner-slider .inner_top_banner img.pc_banner');
  if (isMobileScreen) {

    images = document.querySelectorAll('.home__banner-slider .inner_top_banner img.mobile_banner');
  }
  if (images.length > 0) {
    const arrows = document.querySelectorAll('.banner-arrow');
    // const arrows_cs = document.querySelectorAll('.home__banner-slider .splide__arrow ');
    // const pagination = document.querySelector('.home__banner-slider .splide__pagination'); // Check if pagination element exists
   
    // Wait for all images to load
    Promise.all(Array.from(images).map(img => {
      return new Promise(resolve => {
        if (img.complete) {
          // Image has loaded, can retrieve its height
          resolve();
        } else {
          // Wait for the "load" event of the image
          img.addEventListener('load', () => resolve());
        }
      });
    })).then(() => {
      const imageHeight = images[0].height;
      // const img_home_first = document.querySelector('.home__banner-slider-first .inner_top_banner .pc_banner');
      // const img_home_first_mb = document.querySelector('.home__banner-slider-first .inner_top_banner .mobile_banner');
      // const height_home_first = img_home_first ? img_home_first.offsetHeight : 0;
      // const height_home_first_mb = img_home_first_mb ? img_home_first_mb.offsetHeight : 0;
      arrows.forEach(arrow => {
        arrow.style.top = `${imageHeight / 2}px`;
      });
      // arrows_cs.forEach(arrows_cs => {
      
      //   arrows_cs.style.top = `${height_home_first / 2}px`;
      // });

      // if (pagination) {
      //   pagination.style.top = `${height_home_first - 32}px`;
      // }
      // if (pagination && isMobileScreen) {
      //   pagination.style.top = `${height_home_first_mb - 25}px`;
      // }
      setTimeout(() => {
        document.getElementById("section-sliderbanner").classList.add("loaded");
        const arrows_cs = document.querySelectorAll('.home__banner-slider .banner-arrow');
        const pagination = document.querySelector('.home__banner-slider .swiper-pagination--banner'); // Check if pagination element exists
        
        const img_home_first = document.querySelector('.home__banner-slider-first .inner_top_banner .pc_banner');
        const img_home_first_mb = document.querySelector('.home__banner-slider-first .inner_top_banner .mobile_banner');
        const height_home_first = imageHeight ?? img_home_first.offsetHeight ;
        const height_home_first_mb = imageHeight ?? img_home_first_mb.offsetHeight;

        arrows_cs.forEach(arrow => {
          // if (!arrow.classList.contains('is_active')) {
            arrow.style.top = `${height_home_first / 2}px`;
            arrow.classList.add('is_active');
          // }
        });

        if (pagination) {
          // pagination.style.top = `${height_home_first - 32}px`;
          pagination.classList.add('is_set');
        }
        if (pagination && isMobileScreen ) {
          // pagination.style.top = `${height_home_first_mb - 35}px`;
          pagination.classList.add('is_set');
        }
        
      }, 1400);
    });
  }
};

const setBtnArrowProductSlider = () => {
  const isMobileScreen = window.innerWidth < 768;
  if (isMobileScreen) return;

  let productSliders = document.querySelector('.wrapper-product-slider-banner .listing-item__media-image');
  if(!productSliders) {
    productSliders = document.querySelector('.product-slider .product-image.pt_slide_banner .banner-lazy-img');
  }
  
  const arrowsPrev = document.querySelectorAll('.product-slider .swiper-button-prev');
  const arrowsNext = document.querySelectorAll('.product-slider .swiper-button-next');
  if(productSliders ){
    const actualHeight  = productSliders.height;
    const imageHeight = actualHeight > 160 ? actualHeight : 220;
    const topPosition = (imageHeight / 2) - 19;
    arrowsPrev.forEach(arrow => {
        arrow.style.top = `${topPosition}px`;
      });

      arrowsNext.forEach(arrow => {
        arrow.style.top = `${topPosition}px`;
      });
    }
};

const centerArrowsProductSlider = () => {
  const isMobileScreen = window.innerWidth < 768;
  if (isMobileScreen) return;

  let productSliders = document.querySelectorAll('.product-slider');
  if (productSliders.length > 0) {
    productSliders.forEach((productSlider, index) => {
      const arrowsPrev = productSlider.querySelector('.swiper-button-prev');
      const arrowsNext = productSlider.querySelector('.swiper-button-next');
      let images = productSlider.querySelectorAll('.alt-lazy-img');
      if (index > 0) {
        images = productSlider.querySelectorAll('.banner-lazy-img');
      }
      // Wait for all images to load
      if (images.length > 0) {
        Promise.all(Array.from(images).map(img => {
          return new Promise(resolve => {
            if (img.complete) {
              // Image has loaded, can retrieve its height
              resolve();
            } else {
              // Wait for the "load" event of the image
              img.addEventListener('load', () => resolve());
            }
          });
        })).then(() => {
          const imageHeight = images[0].height;
          arrowsPrev.style.top = `${(imageHeight / 2) - 19}px`;
          arrowsNext.style.top = `${(imageHeight / 2) - 19}px`;
        });
      }
    });
  }
};
const onSwiperInit = (swiper) => {
  bannerSwiper.value = swiper;
  onItemActive(swiper);

  setTimeout(function () {
    if (swiper.autoplay && swiperAutoplay.value) swiper.autoplay.start();
  }, 1000);
}

// Lazy load for banner images
const _loaded = ref(false);
const ktsLazyLoadBanner = () => {
  const bannerLazyImgs = Array.from(document.querySelectorAll('img.banner-lazy-img'));
  if (bannerLazyImgs.length > 0) {
    bannerLazyImgs.forEach((image, index) => {
      image.classList.add("alt-lazy-img");
      if (typeof image.dataset.original_src != 'undefined') {
        image.onload = () => {
          image.removeAttribute("data-original_src");
        }
        image.src = image.dataset.original_src;
      }
    });
  }
};
const revealMainBanner = async () => {
  if (!import.meta.client || _loadedBanner.value || !dataLoad.value) return;
  _loadedBanner.value = true;
  await nextTick();
  ktsLazyLoadBanner();
  altLazyIO();
};

// If the SSR hero data is unavailable, never leave a blank area waiting for a
// mouse, scroll, or touch event. The regular slider becomes the safe fallback.
watch(dataLoad, (isReady) => {
  if (isReady && (!props.firstBanner || hasActivatedMainSlider.value)) revealMainBanner();
}, { immediate: true });

const check_slider = ref(true);
const onSwiperSlideChange = (swiper) => {
  onItemActive(swiper);
  resetProgressBar();
  if (_loaded.value == false) {
    ktsLazyLoadBanner();
    _loaded.value = true;
  }
  const allBoxes = document.querySelectorAll('.pt_box_slider');
  allBoxes.forEach((el, i) => {
    if (i === swiper.realIndex) {
      el.classList.add('active');
    } else {
      el.classList.remove('active');
    }
  });
  check_slider.value = false
}
const mutedVideo = () => {
  const videoBanners = document.querySelectorAll(".wrapper-banner-video .video_banner");
  if (videoBanners && videoBanners.length > 0) {
    videoBanners.forEach((videoBanner, index) => {
      videoBanner.setAttribute("muted", true)
    });
  }
}
// End
const onBannerResize = () => {
  const previousViewport = isMobileViewport.value;
  updateVideoViewport();
  requestAnimationFrame(centerArrows);
  setBtnArrowProductSlider();
  colorSliderMb();
  if (previousViewport !== isMobileViewport.value) syncVideoPlayback();
};

const activateMainSlider = () => {
  hasActivatedMainSlider.value = true;
  void loadItems().then(() => {
    if (dataLoad.value) revealMainBanner();
  });
};

let idleLoadId: number | undefined;
let idleLoadTimeoutId: number | undefined;
const loadSliderWhenIdle = () => {
  if (dataLoad.value) return;

  if ('requestIdleCallback' in window) {
    // The initial poster is the LCP resource. Do not start the hidden carousel
    // until the browser has had a chance to finish critical rendering.
    idleLoadId = window.requestIdleCallback(() => { void loadItems(); }, { timeout: 10000 });
  } else {
    idleLoadTimeoutId = window.setTimeout(() => { void loadItems(); }, 10000);
  }
};

onMounted(async () => {
  // await loadItems();
  // handleStyleTopOption();
  checkMobile.value = window.innerWidth < 768;
  updateVideoViewport();
  videoLoadingEnabled.value = true;
  const activeItem = items.value[activeIndex.value];
  if (activeItem) startVideo(activeItem, isMobileViewport.value ? 'mb' : 'pc');

  // centerArrowsProductSlider();
  setBtnArrowProductSlider();
  colorSliderMb();
  mutedVideo();
  window.addEventListener('resize', onBannerResize);
  document.addEventListener('visibilitychange', syncVideoPlayback);
  window.addEventListener('pageshow', syncVideoPlayback);
  window.addEventListener('pagehide', pauseVideos);

  // Preserve the old behaviour of showing the full carousel on engagement,
  // but do not fetch it during SSR or while the LCP image is in flight.
  ['mousemove', 'scroll', 'touchstart', 'click'].forEach((eventName) => {
    window.addEventListener(eventName, activateMainSlider, { passive: true, once: true });
  });

  if (!props.firstBanner) void loadItems();
  else if (document.readyState === 'complete') loadSliderWhenIdle();
  else window.addEventListener('load', loadSliderWhenIdle, { once: true });
});

onBeforeUnmount(() => {
  videoLoadingEnabled.value = false;
  pauseVideos();
  window.removeEventListener('resize', onBannerResize);
  document.removeEventListener('visibilitychange', syncVideoPlayback);
  window.removeEventListener('pageshow', syncVideoPlayback);
  window.removeEventListener('pagehide', pauseVideos);
  ['mousemove', 'scroll', 'touchstart', 'click'].forEach((eventName) => {
    window.removeEventListener(eventName, activateMainSlider);
  });
  window.removeEventListener('load', loadSliderWhenIdle);
  if (idleLoadId !== undefined && 'cancelIdleCallback' in window) window.cancelIdleCallback(idleLoadId);
  if (idleLoadTimeoutId !== undefined) window.clearTimeout(idleLoadTimeoutId);
});


</script>
<style scoped lang="scss">
  .banner-slider-container {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
    position: relative;
    width: 100%;

    > .slider-banner-first,
    > .sk-home__section--sliderbanner {
      grid-area: 1 / 1;
      width: 100%;
      min-width: 0;
    }
  }

  // Cover the new slider with the existing media until slide change.
  .banner-cover {
    z-index: 1;
    pointer-events: none;
    transition: opacity .3s ease, visibility .3s ease;

    &.banner-hidden {
      opacity: 0;
      visibility: hidden;
    }
  }

  .wrapper-banner-video {
    position: relative;

    .video_banner {
      position: absolute !important;
      inset: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .banner_poster_img {
      position: relative;
      z-index: 2;
      display: block;
      width: 100%;
      height: auto;
      object-fit: cover;
      transition: opacity .3s ease, visibility .3s ease;

      &.poster-hidden {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
      }
    }

    // Keep the poster's display rule from overriding the viewport visibility.
    @media (min-width: 1000px) {
      .mobile_banner {
        display: none;
      }
    }

    @media (max-width: 999px) {
      .pc_banner {
        display: none;
      }
      .mobile_banner {
        height: 100%;
      }
    }
  }

  body:has(.cs_announ_nomal){
    .sk-home__section--sliderbanner {
      .home__banner-slider {
        .item {
          .top_banner {
            .inner_top_banner {
              // height: calc(100vh - 170px);
              @media (min-width: 641px) and (max-width: 999px) {
                  height: calc(100vh - 170px);
              }
              @media screen and (max-width: 640px) {
                height: calc(100vh - 126px);
              }
              @media screen and (max-width: 575px) {
                height: calc(100vh - 178px);
              }
              @media screen and (max-width: 480px) {
                height: calc(100vh - 255px);
              }
              > img {
                // height: calc(100vh - 170px);
                // object-fit: cover;
                @media (min-width: 641px) and (max-width: 999px) {
                  height: calc(100vh - 170px);
                }
                @media screen and (max-width: 640px) {
                  object-fit: cover;
                  height: calc(100vh - 126px);
                }
                @media screen and (max-width: 575px) {
                  height: calc(100vh - 178px);
                }
                @media screen and (max-width: 480px) {
                  height: calc(100vh - 255px);
                }
              }
            }
          }
        }
      }
    }
  }
  
  // .sk-home__section--sliderbanner {
  //   .home__banner-slider {
  //     .item {
  //       .top_banner {
  //         .inner_top_banner {
  //           @media screen and (max-width: 575px) {
  //             height: calc(100vh - 190px);
  //           }
  //           > img {
  //             object-fit: cover;
  //             @media screen and (max-width: 575px) {
  //               height: calc(100vh - 190px);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  body:has(.cs_announ_slide){
    .sk-home__section--sliderbanner {
      .home__banner-slider {
        .item {
          .top_banner {
            .inner_top_banner {
              // height: calc(100vh - 160px);
              @media (min-width: 641px) and (max-width: 999px) {
                  height: calc(100vh - 135px);
              }
              @media screen and (max-width: 640px) {
                height: calc(100vh - 126px);
              }
              @media screen and (max-width: 575px) {
                height: auto;
              }
              > img {
                // object-fit: cover;
                // height: calc(100vh - 160px);
                @media (min-width: 641px) and (max-width: 999px) {
                    height: calc(100vh - 135px);
                }
                @media screen and (max-width: 640px) {
                  object-fit: cover;
                  height: calc(100vh - 126px);
                }
                @media screen and (max-width: 575px) {
                  height: calc(100vh - 232px);
                }
                @media screen and (max-width: 575px) {
                  height: auto;
                }
              }
            }
          }
        }
      }
    }
  }

  :deep(.banner-swiper) {
    position: relative;
  }

  :deep(.banner-swiper .swiper-slide) {
    height: auto;
  }

  :deep(.banner-swiper.swiper-fade .swiper-slide) {
    transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  }

  :deep(.banner-arrow) {
    position: absolute;
    z-index: 10;
    width: 28px;
    height: 50px;
    padding: 14px 4px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: #ffffffe6;
    color: #9f9f9f;
    top: 50%;
    top: calc(50% - 25px);
    cursor: pointer;
    transform: translateY(-50%);

    @media (max-width: 575.98px) {
      display: none;
    }
  }

  :deep(.banner-arrow svg) {
    display: block;
    width: 1em;
    height: 1em;
    margin: auto;
    fill: currentColor;
  }

  :deep(.banner-arrow--prev) {
    left: 0;
  }

  :deep(.banner-arrow--next) {
    right: 0;
  }

  :deep(.swiper-pagination--banner) {
    position: absolute;
    z-index: 10;
    right: auto;
    bottom: 15px;
    left: 0;
    display: flex;
    width: auto;
    padding: 0 12px;
    justify-content: flex-start;

    @media (max-width: 767.98px) {
      right: 0;
      justify-content: center;
    }
  }

  :deep(.swiper-pagination--banner .swiper-pagination__bullet) {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 3px;
    margin: 0 3px;
    padding: 0;
    overflow: hidden;
    border: 0;
    border-radius: 2px;
    background: #bbb;
    opacity: 1;
    cursor: pointer;

    @media (max-width: 767.98px) {
      height: 6px;
      margin: 1px 3px;
    }
  }

  :deep(.swiper-pagination--banner .progress-bar) {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    border-radius: inherit;
    background: #fff;
    animation: fillWhite 19s linear forwards;
  }
    
</style>
